// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/HotTopic/index.css
// module id = 319
// module chunks = 0